import React, { useEffect, useState } from "react";
import Header from "../layout/header";
import { InlineTableOfContentsContext } from "./InlineTableOfContentsProvider";

export interface InlineTableOfContentsProps {
  header?: string;
  data?: Array<{ node: string; text: string }> | any;
  setData?: (data: Array<{ node: string; text: string }>) => void;
  setOpen?: (open: boolean) => void;
  triggerOpen?: (action: boolean) => void;
  openView?: boolean;
  moveToItem?: (item: string) => void;
  selectedItem?: string;
}

function open(): void {
  const element = document.getElementsByClassName(
    "inline-table-of-contents"
  )[0] as HTMLElement;

  element.style.minWidth = window.innerWidth <= 575 ? "100%" : "400px";
}

const InlineTableOfContents = ({ header }: any): JSX.Element => {
  const [detailData, setDetailData] = useState<
    { value: string; label: string }[]
  >([]);

  const { data, openView, moveToItem, triggerOpen } = React.useContext<any>(
    InlineTableOfContentsContext
  );

  function close(): void {
    const element = document.getElementsByClassName(
      "inline-table-of-contents"
    )[0] as HTMLElement;

    element.style.minWidth = "0";
    triggerOpen(false);
  }

  useEffect(() => {
    const modifiedData = createSummaryStructure(data || []);
    setDetailData(modifiedData);

    if (openView) {
      open();
    } else {
      close();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, openView]);

  const createSummaryStructure = (data: any) => {
    const summaryData: any = [];

    const setPosition = (item: any) => {
      switch (item) {
        case "H1":
          return "1";
        case "H2":
          return "2";
        case "H3":
          return "3";
        case "H4":
          return "4";
        case "H5":
          return "5";
        case "H6":
          return "6";
        default:
          break;
      }
    };

    data.forEach((item: any) => {
      summaryData.push({
        label: item.text,
        position: setPosition(item.node),
      });
    });
    return summaryData;
  };

  const handleHeaderClick = (item: any) => {
    moveToItem(item.target.innerText);
    if (window.innerWidth <= 575) {
      triggerOpen(false);
    }
  };

  return (
    <div className="inline-table-of-contents">
      <div className="detail-header">
        {header !== undefined ? header : "Table of contents"}
        <button
          type="button"
          className="detail-close-button"
          onClick={(): void => close()}
        >
          <span className="icon icon-close-dark" />
        </button>
      </div>
      <div className="detail-body">
        <div
          className="col hmi-inner-content parameter-page no-padding"
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          {detailData.map((item: any): JSX.Element => {
            return (
              <div
                key={item.label}
                className={`row  pos-${item.position}`}
                onClick={handleHeaderClick}
              >
                <div className="col-12">
                  <div className="inner wc">
                    <div
                      className="summary-parameter"
                      style={{ display: "flex", alignItems: "start" }}
                    >
                      <div className="detail-info-header">{item.label}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InlineTableOfContents;
